<template>
    <footer class="footer">
      <div class="container">
        <nav class="footer-navigation">
          
                    
          <ul>
            <li><router-link   :to="{ name: 'dcma' }">DCMA</router-link></li>
            <li><router-link   :to="{ name: 'aboutUs' }">About Us</router-link></li>
            <li><router-link   :to="{ name: 'privacyPolicy' }"> Privacy Policy </router-link></li>
            <li><router-link   :to="{ name: 'termsConditions' }"> Terms & Conditions </router-link></li>
            <li><router-link   :to="{ name: 'contactUs' }">Contact Us </router-link></li>
          </ul>
        </nav>
        <div class="footer-text">
          <p>2022 © <router-link   :to="{ name: 'allMatches' }">Planet Cricket</router-link></p>
        </div>
      </div>
    </footer>
</template>

<script>
    import allMatches from '../matches/AllMatches.vue'

    export default {
        name: 'Header',

        components: {
            'datepicker': () => import('vuejs-datepicker')
        },

        data() {
            return {
                date: new Date(),
                liveCount: 0,
                searchInput: '',
                showCalendar: false,
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.getLiveCount()
            }
        },
        mounted() {
            this.$root.$on('date', (text) => { // here you need to use the arrow function
                this.date = text;
            }),
                    this.getLiveCount()
            if (isBrowser)
                setInterval(() => this.getLiveCount(), 1000 * 60)
        },

        methods: {
            getLiveCount() {
                clickedElement = null;
                return this.$axios
                        .get(this.$LIVE_COUNT_API, {params: {ttl: 0}})
                        .then(response => {
                            this.liveCount = response.data.result.count || 0
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },

            switchTheme() {
                if (this.$store.getters.theme == 'dark') {
                    this.$store.commit('switchTheme', 'light')
                    document.querySelector('body').classList.add('light-theme-active')
                } else {
                    this.$store.commit('switchTheme', 'dark')
                    document.querySelector('body').classList.remove('light-theme-active')
                }
            },
            search() {
                if (this.searchInput) {
                    if (isBrowser) {
                        window.closeMenu();
                    }
                    this.$router.push({name: 'search', query: {search: this.searchInput}}).catch(() => {
                    })
                }
            },
            closeCalendar() {
                this.showCalendar = false
            },
            updateDate() {
                this.date = new Date(this.date).toISOString().slice(0, 10);
                this.$router.push({name: 'allMatches', params: {date: this.date}})

                this.closeCalendar()
                if (isBrowser)
                    window.closeMenu()
            },
        }
    }
</script>
